module.exports = __webpack_public_path__ + "img/scbh.2957f4d8.svg";